/**
 * Health Fund Product Selector - Dynamic Load
 * Responsible for determining if the PS Quote Form needs to load, and for actually loading the files.
 * @author Rhys Lloyd
 */

//
// Utilities
import debug from "debug";
const log = debug("hf-ps.dynamic-load");

//
// Dependencies
import * as registry from "@core/registry";
import { HF_PRODUCT_SELECTOR_MODULE } from "@core/registry/names";

//
// Constants
export const MODULE_NAME = HF_PRODUCT_SELECTOR_MODULE;
export const MODULE_SELECTOR = "[data-hf-ps]";
export const ASSETS = [
	"../styles/nt-datepicker.module.css",
	"../styles/nthf-product-selector.module.css",
	"../scripts/core-product-selector.module.js",
];

//
// Load
export default function load() {
	registry.dynamicLoader(MODULE_NAME, MODULE_SELECTOR, ASSETS);
}



// WEBPACK FOOTER //
// ./project/client/src/site__nt/modules/product-selector/dynamic-load.js